

export class OptionModel {

    isEasyMode = false;
    isAllowUndo = true;
}